<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      ref="searchBox"
      @sub="sub"
      @reset="reset"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox
          label="待我处理"
          name="type"
          v-model="prop.form.waitDeal"
        />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {
  costDetailCostType,
} from 'api/cost';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      flag: false,
      searchBoxData: {
        costTypeOptions: [], // 费用类型
        stateOptions: [], // 状态
        orgIdOptions: [], // 部门
        form: [
          { // 待我处理
            label: '待我处理',
            value: 'waitDeal',
            default: !this.$route.query.busiCode,
            slot: true,
          },
          { // 申请单号
            label: '申请单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入申请单号',
            disabled: false,
          },
          { // 申请时间
            label: '申请时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择申请时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 费用类型
            label: '费用类型',
            value: 'costType',
            type: 'cascader',
            normal: true,
            default: [-1],
            placeholder: '请选择费用类型',
          },
          { // 状态
            label: '状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择状态',
          },
          { // 部门
            label: '部门',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请选择部门',
          },
          { // 申请金额
            label: '申请金额',
            value: 'Amt',
            type: 'inputrange',
            default: [],
            placeholder: '请输入申请金额',
            attr: {
              type: 'daterange',
            },
          },
          { // 申请人
            label: '申请人',
            value: 'applyUserName',
            type: 'input',
            placeholder: '请输入申请人',
          },
        ],
      },
    };
  },
  methods: {
    reset (val) {
      if (val === 'reset') {
        this.flag = true;
        this.setFormAttrVal({
          form: this.searchBoxData,
          attr: 'disabled',
          value: !this.$route.query.busiCode,
          names: ['busiCode'],
        });
      }
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 申请时间
      if (searchBoxData.Time && searchBoxData.Time[0]) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0], 1);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1], 1);
      }
      delete searchBoxData.Time;
      // 申请金额
      if (searchBoxData.Amt && searchBoxData.Amt[0]) {
        searchBoxData.startAmt = searchBoxData.Amt[0];
      }
      if (searchBoxData.Amt && searchBoxData.Amt[1]) {
        searchBoxData.endAmt = searchBoxData.Amt[1];
      }
      delete searchBoxData.Amt;
      // 费用类型
      searchBoxData.costType = searchBoxData.costType[searchBoxData.costType.length - 1];

      if (!this.flag) {
        const busiCode = this.$route.query.busiCode;
        if (busiCode) {
          this.$refs.searchBox.setVal('busiCode', busiCode);
          searchBoxData.busiCode = busiCode;
        }
      } else {
        this.$refs.searchBox.setVal('busiCode', '');
        this.flag = false;
      }

      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
    // 从其他页面跳转过来
    jumpHereFromAnotherPage () {
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'disabled',
        value: !!this.$route.query.busiCode,
        names: ['busiCode'],
      });
    },
  },
  watch: {
    '$route.query.busiCode': function () {
      this.jumpHereFromAnotherPage();
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...await getDepartmentAllList(),
    ];
    this.searchBoxData.costTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...await costDetailCostType(),
    ];
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_APPLY_STATE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.jumpHereFromAnotherPage();
  },
};
</script>

<style lang="scss" scoped>
</style>
